import {LitElement, html, nothing} from "lit";
import {customElement, property} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";

import {checkboxStyles} from "./Checkbox.styles.js";

@customElement("pn-checkbox")
export class Checkbox extends LitElement {
	static styles = [checkboxStyles];

	@property() className:  string;
	@property() checked:    boolean;
	@property() cssClasses: string[];
	@property() disabled = false;
	@property() error:      string | boolean = false;
	@property() htmlFor = null;
	@property() onChange:   (event: InputEvent) => void;
	@property() inputAttribute = null;
	@property() required = false;

	isError() {
		return typeof this.error === "string"
			? (this.error !== "" && this.error !== "false")
			: this.error;
	}

	renderErrorMessage() {
		if (!(this.isError() && this.required))
			return nothing;

		let message = "Required";
		if (typeof this.error === "string")
			message = this.error;

		return html`
			<span
				class="error-message"
				part="error"
				role="alert"
			>${message}</span>
		`;
	}

	render() {
		const classes = classMap({
			"pn-checkbox": true,
			disabled:      this.disabled,
			error:         this.isError()
			// ...this.cssClasses
		});

		const inputElement = html`<input
			.checked=${this.checked}
			data-additional=${this.inputAttribute ?? nothing}
			?disabled=${this.disabled}
			htmlFor=${this.htmlFor ?? nothing}
			@change=${this.onChange}
			type="checkbox"
		/>`;
		const customCheckboxElement = html`<span class="custom-checkbox"></span>`;

		if (this.childNodes.length > 0) {
			return html`
				<label class=${classes}>
					${inputElement}
					${customCheckboxElement}

					<div class="custom-checkbox-label"><slot/></div>
				</label>
			`;
		} else {
			return html`
				<div class=${classes}>
					${inputElement}
					${customCheckboxElement}
				</div>
			`;
		}
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-checkbox": Checkbox;
	}
}
